import React from 'react';
import ChallengeResponseForm from '../../../../widgets/ChallengeResponseForm';
import { KIND_EXPIRED, MESSAGES } from '../../../../auth/challengeErrors';

// Response step of the ID login: same form as the QR login, verification on check-challenge.
const Component = ({ actions, loginInformation, attemptError }) => (
    <ChallengeResponseForm
        loginInformation={loginInformation}
        attemptError={attemptError}
        onSubmit={(response) => actions.checkChallenge(loginInformation.challengeId, loginInformation.userId, response)}
        onExpire={() => actions.setRefusal({ kind: KIND_EXPIRED, message: MESSAGES[KIND_EXPIRED] })}
    />
);

export default Component;
